import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { useDialogContext } from './Context';
const Panel = forwardRef((props, ref) => {
    const { onClose } = useDialogContext();
    const panelRef = useRef(null);
    useImperativeHandle(ref, () => panelRef.current);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (panelRef.current && !panelRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);
    return _jsx("div", { ref: panelRef, ...props });
});
Panel.displayName = 'Panel';
export { Panel };
//# sourceMappingURL=Panel.js.map